// extracted by mini-css-extract-plugin
export default {"productsWrapper":"styles_productsWrapper__4OrM9","cardWrapper":"styles_cardWrapper__moJn7","footerWrapper":"styles_footerWrapper__IzGS5"};